import React from "react";
import "./Winpopup.css";
import Button from "./../Button/Button";
import { useLocation, useNavigate } from "react-router-dom";
import homeIcon from '../../Assets/img/homeIcon.png'
import retryIcon from '../../Assets/img/retryIcon.png'

const LoosePopup = () => {
  const { state } = useLocation();
  const global_data = JSON.parse(localStorage.getItem("global_data"));
  const navigate = useNavigate();
  const homePage = () => {
    navigate("/");
  };

  const playAgain = () => {
    navigate(`/playgame/${state?.gameName}`, { replace: false });
  };
  // console.log(state?.score);

  return (
    <>
      <div className="container-1280 loose-game hz-game-end">
        <div className="row pop-row">
          <div className="col-md-8">
            <div className="big-win">
              <div className="big-win-container ">
                <img src={require("../../Assets/img/loose.png")} alt="matic" />
              </div>
              <div className="scrored-container">
                <h3>Your Score</h3>
                <h2>{state?.score}</h2>

                <div className="gold">
                  <h3>YOU LOOSE</h3>
                  <img
                    src={require("../../Assets/img/treasure.png")}
                    alt="matic"
                  />
                  <h3>3, 000</h3>
                </div>
              </div>

              <h3 className="trans">Transaction Details</h3>
            </div>
          </div>
        </div>
        <div className="row button-row">
          <div className="col-lg-6 btn-box">
            <Button value="Home" onClick={() => homePage()} icon = {homeIcon} />
            <Button value="Play again" onClick={() => playAgain()} icon = {retryIcon} />
          </div>
        </div>
        <div className="row score-row">
          <div className="col-lg-2 share-btn">
            <img
              src={require("./../../Assets/img/discord.png")}
              alt="discord"
            />
            <h4>Join The Community</h4>
          </div>
          <div className="col-lg-8  score-box">
            <h3>{global_data?.data?.count?.total_played}</h3>
            <p>Game played till now!</p>
          </div>
          <div className="col-lg-2 share-btn">
            <img src={require("./../../Assets/img/share.png")} alt="share" />
            <h4>ShareYour Achievement</h4>
          </div>
        </div>
      </div>
    </>
  );
};
export default LoosePopup;
